"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontType = void 0;
var FontType;
(function (FontType) {
    FontType["ARIAL"] = "arial";
    FontType["FS_ALBERT"] = "fs-albert";
    FontType["NOKIA"] = "nokia";
    FontType["KLARNA"] = "klarna";
    FontType["KLARNA_TEXT"] = "klarna-text";
    FontType["MISTER_PIXEL"] = "mister_pixel";
    FontType["AMSI"] = "amsi";
    FontType["BEBAS"] = "bebas";
})(FontType || (exports.FontType = FontType = {}));
